import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleBeginner from "../pages/article/articles/BeginnerTutorial";
import ArticlePricing from "../pages/article/articles/PricingGuide";
import ArticleSafety from "../pages/article/articles/SafetyTips";
import ArticleVsTraditional from "../pages/article/articles/VsTraditional";
import ArticleBestPractices from "../pages/article/articles/BestPractices";
import ArticleToolsComparison from "../pages/article/articles/ToolsComparison";
import ArticleBulkOrdering from "../pages/article/articles/BulkOrdering";
import ArticleFaq from "../pages/article/articles/FaqTroubleshooting";
import ArticleMobile from "../pages/article/articles/MobileGuide";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mulebuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/mulebuy-spreadsheet-beginner-tutorial",
    element: <ArticleBeginner />,
  },
  {
    path: "/mulebuy-spreadsheet-pricing-guide",
    element: <ArticlePricing />,
  },
  {
    path: "/mulebuy-spreadsheet-safety-tips",
    element: <ArticleSafety />,
  },
  {
    path: "/mulebuy-spreadsheet-vs-traditional-shopping",
    element: <ArticleVsTraditional />,
  },
  {
    path: "/mulebuy-spreadsheet-best-practices-2026",
    element: <ArticleBestPractices />,
  },
  {
    path: "/mulebuy-spreadsheet-tools-comparison",
    element: <ArticleToolsComparison />,
  },
  {
    path: "/mulebuy-spreadsheet-bulk-ordering",
    element: <ArticleBulkOrdering />,
  },
  {
    path: "/mulebuy-spreadsheet-faq-troubleshooting",
    element: <ArticleFaq />,
  },
  {
    path: "/mulebuy-spreadsheet-mobile-guide",
    element: <ArticleMobile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;